import { Text, Stack, HStack, Box, Flex } from "@chakra-ui/react";
import { textSecondary, textPrimary } from "../../../../utils/colors";
import StatusButtonNew from "../../../../components/buttons/StatusButtonNew";
import MoreButtonLite from "../../../../components/buttons/MoreButtonLite";

export const columnsDesktop = (
  slug,
  dispatch,
  translate,
  handleSortChange,
  updateProfessionStatus,
  setShowDeleteConfirmation,
  setProfessionId,
  setProfessionName,
  setInEmployees,
  openEditSidePanelModal,
  hasAccessToEdit
) => {
  return [
    // {
    //   Header: "#",
    //   id: "index",
    //   accessor: (_row, i) => {
    //     // Adjust the index based on the page and pageSize
    //     const adjustedIndex = (page - 1) * pageSize + i + 1;
    //     return (
    //       <Text
    //         overflow="hidden"
    //         whiteSpace="nowrap"
    //         fontSize="sm"
    //         color={textSecondary}
    //         fontWeight="500"
    //       >
    //         {adjustedIndex}
    //       </Text>
    //     );
    //   },
    // },
    {
      Header: () => (
        <Box onClick={() => handleSortChange("name")}>
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("service.columnName")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "name",
      width: 420,
      disableSortBy: true,
      Cell: ({ row }) => {
        const { name } = row.original;

        // console.log("handleSortChange", handleSortChange);

        return (
          <HStack gap={2}>
            <Stack gap={0} overflow="hidden">
              <Text
                fontSize="15px"
                color={textPrimary}
                fontWeight="600"
                textAlign="left"
                isTruncated // This will add ellipsis
                maxW="360px"
              >
                {name}
              </Text>
            </Stack>
          </HStack>
        );
      },
    },

    {
      Header: () => (
        <Box onClick={() => handleSortChange("professionGroup")}>
          <Flex align="center" cursor="pointer">
            <Text mr={2}>{translate("profession.columnProfessionGroup")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "professionGroup",
      disableSortBy: true,
      Cell: ({ row }) => {
        const { professionGroup } = row.original;

        const name = professionGroup ? professionGroup.name : "";

        // console.log("professionGroup", professionGroup);
        return (
          <Text
            fontSize="sm"
            color={textSecondary}
            fontWeight="500"
            textAlign="left"
            isTruncated
            maxW="200px"
          >
            {name}
          </Text>
        );
      },
    },

    {
      Header: () => (
        <Box onClick={() => handleSortChange("status")} w="100%">
          <Flex align="center" cursor="pointer" justify="flex-end" w="100%">
            <Text mr={2}>{translate("patient.columnStatus")}</Text>
          </Flex>
        </Box>
      ),
      accessor: "status",
      preventRowClick: true,
      disableSortBy: true,
      Cell: ({ row }) => {
        const { status, _id, usedInEmployees } = row.original;

        const handleUpdateStatus = (newStatus) => {
          dispatch(updateProfessionStatus(slug, _id, newStatus));
        };

        return (
          <HStack gap={0} justify="flex-end">
            <StatusButtonNew
              currentStatus={status}
              onUpdateStatus={handleUpdateStatus}
              options="serviceNew"
              isUnclickable={!hasAccessToEdit}
              p="0 2.5rem"
            />

            <MoreButtonLite
              id={_id}
              viewHandler={() => {
                openEditSidePanelModal();
                setProfessionId(_id); // Set the profession ID for viewing
                // e.stopPropagation();
                // openViewSidePanelModal(_id);
              }}
              deleteHandler={true}
              setShowDeleteConfirmation={() => {
                setProfessionId(_id); // Set the user ID for deletion
                setShowDeleteConfirmation(true); // Open confirmation
                setInEmployees(usedInEmployees);
                setProfessionName(row.original.name);
              }}
            />

            {/* <StatusButton
              currentStatus={status}
              onUpdateStatus={handleUpdateStatus}
              options="active"
              isUnclickable={!isAdmin}
            />
            <MoreButton
              id={_id}
              deleteHandler={deleteServiceHandler}
              deleteButtonDisabled={!isAdmin}
              editHandler={(e) => {
                e.stopPropagation();
                openEditSidePanelModal(_id);
              }}
              editButtonDisabled={!isAdmin}
            /> */}
          </HStack>
        );
      },
    },
  ];
};
